import styled from "@emotion/styled";
import { Body1 } from "@material/react-typography";
import React, { useMemo } from "react";
import { Chevron } from "~/components/chevron";
import { FolderIcon } from "./FolderIcon";
import { FolderType } from "./types";
import classNames from "classnames";
import { SyncStatusDisplay } from "./SyncStatusDisplay";
import { SyncStatus } from "~/gql/types";

const FolderTitleRowElem = styled(Body1)`
  &.mdc-typography.mdc-typography--body1 {
    margin: 4px;
    cursor: pointer;
    border: 2px solid var(--mdc-theme-surface);
    width: 100%;

    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 24px;

    &.expandable {
      padding-left: 0px;
      overflow: hidden;
    }

    &.selected {
      border: 2px solid #333;
      border-radius: 4px;
      overflow: hidden;
    }
  }
`;

type FolderTitleRowProps = {
  type: FolderType;
  childCount: number;
  name: string;
  expanded: boolean;
  onClick: React.DispatchWithoutAction;
  selectable: boolean;
  onSelect: React.DispatchWithoutAction;
  selected: boolean;
  syncStatus: SyncStatus | null;
};

export const FolderTitleRow: React.FC<FolderTitleRowProps> = ({
  type,
  childCount,
  name,
  expanded,
  onClick,
  selectable,
  onSelect,
  selected,
  syncStatus,
}) => {
  const expandable = childCount > 0 && type !== "ProjectFolder";

  const clickHandler = useMemo(
    () => (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    },
    [onClick]
  );

  return (
    <FolderTitleRowElem
      tag="button"
      className={classNames({ expandable, selected })}
      onClick={clickHandler}
      tabIndex={selectable ? 0 : -1}
      onFocus={() => onSelect()}
    >
      {expandable && <Chevron {...{ expanded }} />}
      <FolderIcon type={type} />
      <span>{name}</span>
      {syncStatus && <SyncStatusDisplay status={syncStatus} />}
    </FolderTitleRowElem>
  );
};
